/** Supported view modes */
export enum DisplayModes {
  view = 'view',
  edit = 'edit',
  create = 'create',
}
